require('vant/lib/style/base.less');
require('vant/lib/info/index.less');
require('./index.less');
